// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* FastProductsModal.module.css */
.FastProductsModal_overlay__v0jKM {
  position: fixed;
  inset: 0;
  background: rgba(0,0,0,0.6);
  display:flex;
  align-items:center;
  justify-content:center;
  z-index: 2000;
}

.FastProductsModal_modal__7eNEl {
  width: 680px;
  max-width: calc(100% - 40px);
  background: #fff;
  border-radius: 8px;
  display:flex;
  flex-direction:column;
  box-shadow: 0 10px 30px rgba(0,0,0,0.3);
  overflow: hidden;
}

.FastProductsModal_header__sIqPH {
  display:flex;
  align-items:center;
  justify-content:space-between;
  padding: 12px 16px;
  border-bottom: 1px solid #eee;
}

.FastProductsModal_title__QT23k { font-weight: 600; font-size: 16px; }
.FastProductsModal_closeBtn__1BEnL { background: transparent; border: none; cursor: pointer; }

.FastProductsModal_content__yzT1p {
  padding: 12px;
  flex: 1 1;
  display: flex;
  flex-direction: column;
}

.FastProductsModal_loading__5Y3k8 { text-align:center; margin-top: 60px; }

.FastProductsModal_grid__myOQ- {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 10px;
  flex: 1 1;
  overflow-y: auto;
  padding-bottom: 6px;
}

.FastProductsModal_card__lm-yn, .FastProductsModal_cardEmpty__smMna {
  background: #fafafa;
  border: 1px solid #eee;
  border-radius: 6px;
  min-height: 110px;
  display:flex;
  flex-direction:column;
  justify-content:center;
  align-items:center;
  padding: 8px;
  cursor: pointer;
}

.FastProductsModal_card__lm-yn:hover { 
    box-shadow: 0 6px 18px rgba(0,0,0,0.08); 
    transform: translateY(-2px); 
}

.FastProductsModal_cardName__nA7an { 
    font-size:14px; 
    font-weight: 600; 
    margin-bottom: 6px; 
    text-align:center; 
}
.FastProductsModal_cardArticle__Oom17 { 
    font-size:12px; 
    color:#666; 
    margin-bottom: 6px; 
}
.FastProductsModal_cardPrice__jC2Yt { 
    font-size:13px; 
    font-weight:700; 
}

.FastProductsModal_cardEmpty__smMna {
  background: transparent;
  border: none;
  pointer-events: none;
}

.FastProductsModal_pager__kJxvJ {
  display:flex;
  justify-content:center;
  align-items:center;
  gap:8px;
  margin-top: 8px;
  padding-top: 6px;
  border-top: 1px solid #f0f0f0;
}

.FastProductsModal_pager__kJxvJ button { 
    padding:6px 10px; 
    border-radius:4px; 
    border:1px solid #ddd;
    background:#fff; 
    cursor:pointer; 
}
.FastProductsModal_pager__kJxvJ button[disabled] { 
    opacity:0.5; 
    cursor: not-allowed; 
}
.FastProductsModal_pageInfo__AlDUV { 
    font-size:13px; 
    color:#444; 
}
`, "",{"version":3,"sources":["webpack://./src/pages/tables/customComponentsTable/FastProductsModal.module.css"],"names":[],"mappings":"AAAA,iCAAiC;AACjC;EACE,eAAe;EACf,QAAQ;EACR,2BAA2B;EAC3B,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;EACtB,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,4BAA4B;EAC5B,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;EACZ,qBAAqB;EACrB,uCAAuC;EACvC,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,6BAA6B;EAC7B,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA,kCAAS,gBAAgB,EAAE,eAAe,EAAE;AAC5C,qCAAY,uBAAuB,EAAE,YAAY,EAAE,eAAe,EAAE;;AAEpE;EACE,aAAa;EACb,SAAO;EACP,aAAa;EACb,sBAAsB;AACxB;;AAEA,oCAAW,iBAAiB,EAAE,gBAAgB,EAAE;;AAEhD;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,SAAO;EACP,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,iBAAiB;EACjB,YAAY;EACZ,qBAAqB;EACrB,sBAAsB;EACtB,kBAAkB;EAClB,YAAY;EACZ,eAAe;AACjB;;AAEA;IACI,uCAAuC;IACvC,2BAA2B;AAC/B;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,kBAAkB;IAClB,iBAAiB;AACrB;AACA;IACI,cAAc;IACd,UAAU;IACV,kBAAkB;AACtB;AACA;IACI,cAAc;IACd,eAAe;AACnB;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,OAAO;EACP,eAAe;EACf,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,qBAAqB;IACrB,eAAe;IACf,cAAc;AAClB;AACA;IACI,WAAW;IACX,mBAAmB;AACvB;AACA;IACI,cAAc;IACd,UAAU;AACd","sourcesContent":["/* FastProductsModal.module.css */\n.overlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(0,0,0,0.6);\n  display:flex;\n  align-items:center;\n  justify-content:center;\n  z-index: 2000;\n}\n\n.modal {\n  width: 680px;\n  max-width: calc(100% - 40px);\n  background: #fff;\n  border-radius: 8px;\n  display:flex;\n  flex-direction:column;\n  box-shadow: 0 10px 30px rgba(0,0,0,0.3);\n  overflow: hidden;\n}\n\n.header {\n  display:flex;\n  align-items:center;\n  justify-content:space-between;\n  padding: 12px 16px;\n  border-bottom: 1px solid #eee;\n}\n\n.title { font-weight: 600; font-size: 16px; }\n.closeBtn { background: transparent; border: none; cursor: pointer; }\n\n.content {\n  padding: 12px;\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n}\n\n.loading { text-align:center; margin-top: 60px; }\n\n.grid {\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  gap: 10px;\n  flex: 1;\n  overflow-y: auto;\n  padding-bottom: 6px;\n}\n\n.card, .cardEmpty {\n  background: #fafafa;\n  border: 1px solid #eee;\n  border-radius: 6px;\n  min-height: 110px;\n  display:flex;\n  flex-direction:column;\n  justify-content:center;\n  align-items:center;\n  padding: 8px;\n  cursor: pointer;\n}\n\n.card:hover { \n    box-shadow: 0 6px 18px rgba(0,0,0,0.08); \n    transform: translateY(-2px); \n}\n\n.cardName { \n    font-size:14px; \n    font-weight: 600; \n    margin-bottom: 6px; \n    text-align:center; \n}\n.cardArticle { \n    font-size:12px; \n    color:#666; \n    margin-bottom: 6px; \n}\n.cardPrice { \n    font-size:13px; \n    font-weight:700; \n}\n\n.cardEmpty {\n  background: transparent;\n  border: none;\n  pointer-events: none;\n}\n\n.pager {\n  display:flex;\n  justify-content:center;\n  align-items:center;\n  gap:8px;\n  margin-top: 8px;\n  padding-top: 6px;\n  border-top: 1px solid #f0f0f0;\n}\n\n.pager button { \n    padding:6px 10px; \n    border-radius:4px; \n    border:1px solid #ddd;\n    background:#fff; \n    cursor:pointer; \n}\n.pager button[disabled] { \n    opacity:0.5; \n    cursor: not-allowed; \n}\n.pageInfo { \n    font-size:13px; \n    color:#444; \n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"overlay": `FastProductsModal_overlay__v0jKM`,
	"modal": `FastProductsModal_modal__7eNEl`,
	"header": `FastProductsModal_header__sIqPH`,
	"title": `FastProductsModal_title__QT23k`,
	"closeBtn": `FastProductsModal_closeBtn__1BEnL`,
	"content": `FastProductsModal_content__yzT1p`,
	"loading": `FastProductsModal_loading__5Y3k8`,
	"grid": `FastProductsModal_grid__myOQ-`,
	"card": `FastProductsModal_card__lm-yn`,
	"cardEmpty": `FastProductsModal_cardEmpty__smMna`,
	"cardName": `FastProductsModal_cardName__nA7an`,
	"cardArticle": `FastProductsModal_cardArticle__Oom17`,
	"cardPrice": `FastProductsModal_cardPrice__jC2Yt`,
	"pager": `FastProductsModal_pager__kJxvJ`,
	"pageInfo": `FastProductsModal_pageInfo__AlDUV`
};
export default ___CSS_LOADER_EXPORT___;
